import { useEffectEvent, useRef, useState } from "react";
import { MESSAGE_HIGHLIGHT_MS } from "../-utils/scrollToReplyTarget";

export function useMessageHighlight() {
    const [highlightedMessageId, setHighlightedMessageId] = useState<string | null>(
        null,
    );
    const highlightGenerationRef = useRef(0);

    const highlightMessage = useEffectEvent((messageId: string) => {
        highlightGenerationRef.current += 1;
        const generation = highlightGenerationRef.current;

        setHighlightedMessageId(null);

        requestAnimationFrame(() => {
            setHighlightedMessageId(messageId);

            window.setTimeout(() => {
                if (highlightGenerationRef.current === generation) {
                    setHighlightedMessageId(null);
                }
            }, MESSAGE_HIGHLIGHT_MS);
        });
    });

    return { highlightedMessageId, highlightMessage };
}
